import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PRICE_NEW, PRICE_OLD, PRODUCT_NAME } from "../../lib/site";

export const StickyCta = ({ onBuy }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.div
      data-testid="sticky-cta"
      className="fixed inset-x-0 bottom-0 z-[60] md:hidden"
      initial={{ y: "115%" }}
      animate={{ y: visible ? "0%" : "115%" }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="m-3 flex items-center justify-between gap-3 rounded-2xl bg-choc px-5 py-3.5 shadow-2xl shadow-choc-deep/50">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-cream/55">
            {PRODUCT_NAME}
          </div>
          <div className="mt-0.5 flex items-baseline gap-2">
            <s className="text-xs text-white/40">{PRICE_OLD}</s>
            <span className="font-display text-xl font-semibold text-white">{PRICE_NEW}</span>
          </div>
        </div>
        <button
          data-testid="sticky-cta-button"
          onClick={onBuy}
          className="shrink-0 rounded-full bg-brick px-5 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-brick-dark"
        >
          Zabezpiecz lokal
        </button>
      </div>
    </motion.div>
  );
};
